import { Button } from "@/components/ui/button";
import { Check, Sparkles } from "lucide-react";
import PriceTag from "@/components/PriceTag";
import GuaranteeBadges from "@/components/GuaranteeBadges";
import PaymentLogos from "@/components/PaymentLogos";

const FinalCTASection = () => {
  const handleCTAClick = () => {
    window.open("https://payhip.com/b/NWTP2", "_blank");
  };

  const benefits = [
    "150+ natürliche Mittel mit wissenschaftlicher Grundlage",
    "200+ Studien analysiert und referenziert",
    "Präzise Dosierungen und Anwendungsanleitungen",
    "Quellenverzeichnis mit PubMed-Links (40 Seiten)",
    "Traditionelles Wissen + moderne Forschung vereint",
    "Sofortiger PDF-Download – auf allen Geräten nutzbar"
  ];

  return (
    <section className="py-24 bg-card relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-accent/5" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 space-y-4">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground">
              Zugang zum vollständigen Wissen
            </h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              600 Seiten fundiertes Wissen über natürliche Mittel – wissenschaftlich belegt, praktisch umsetzbar
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-12">
            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center mt-0.5">
                    <Check className="w-4 h-4 text-primary" />
                  </div>
                  <span className="text-foreground">{benefit}</span>
                </div>
              ))}
            </div>

            <div className="p-8 rounded-2xl gradient-card shadow-premium border-2 border-primary/20 hover:border-primary/30 transition-all duration-300 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-radial from-primary/5 to-transparent" />
              <div className="text-center space-y-6 relative z-10">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full border border-primary/20">
                  <Sparkles className="w-5 h-5 text-primary" />
                  <span className="text-sm font-semibold text-primary">Einführungspreis</span>
                </div>
                
                <div className="space-y-3 pt-4">
                  <PriceTag />
                  <div className="text-muted-foreground">Einmaliger Kauf, kein Abo</div>
                </div>

                <Button
                  size="lg"
                  onClick={handleCTAClick}
                  className="group relative w-full bg-primary hover:bg-primary/90 text-primary-foreground text-base md:text-lg py-5 md:py-6 shadow-premium hover:shadow-glow hover:scale-105 transition-all duration-300 overflow-hidden micro-bounce hover-glow"
                >
                  <span className="relative z-10">Jetzt für 19,99€ herunterladen</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
                </Button>

                <PaymentLogos />
                <GuaranteeBadges />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
